import React from "react";
import {withStyles,TextField} from "@material-ui/core";
import {withTranslation} from "react-i18next";
import {DatePicker} from "@material-ui/pickers";
import clsx from "clsx";

const styles = {
    datepicker: {

    }
}
function AppDatePicker(props){
    const {t,classes,className,i18n,tReady,TextFieldProps,format,...otherProps} = props;
    return <DatePicker
        format={"DD/MM/YYYY"}
        color={"primary"}
        invalidDateMessage={t("text.date_picker.invalid")}
        clearLabel={t("text.date_picker.clear")}
        cancelLabel={t("text.date_picker.cancel")}
        todayLabel={t("text.date_picker.today")}
        renderInput={(props)=><TextField {...props} className={clsx(classes.datepicker,{[className]:!!className})}/>}
        TextFieldProps={{
            helperText: "",
            ...TextFieldProps
        }}
        {...otherProps}
    />
}

export default withStyles(styles)(withTranslation()(AppDatePicker));
